import React from 'react';
import './LoadingScreen.css';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="logo-container">
          <svg 
            className="logo-animated" 
            width="147" 
            height="98" 
            viewBox="0 0 737 493" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              className="logo-path logo-path-1" 
              d="M104.15 421.83H186.043C215.602 421.83 232.12 405.124 232.12 375.017V47.16C232.12 17.2282 215.602 0.522095 186.043 0.522095H104.15C74.7652 0.522095 58.2473 17.2282 58.2473 47.16V375.017C58.2473 405.124 74.7652 421.83 104.15 421.83ZM324.272 421.83H406.341C435.725 421.83 452.243 405.124 452.243 375.017V202.737C452.243 172.804 435.725 156.098 406.341 156.098H324.272C294.888 156.098 278.371 172.804 278.371 202.737V375.017C278.371 405.124 294.888 421.83 324.272 421.83Z" 
            />
            <g clipPath="url(#clip0_2002_1423)">
              <path 
                className="logo-path logo-path-2" 
                d="M731.304 118.421V44.762C731.304 34.879 723.452 28.3933 713.753 30.4008L614.298 52.1742C602.598 54.645 596.286 61.1308 596.286 71.4769L596.748 291.065C597.671 301.411 592.591 308.359 583.508 310.213L551.947 316.853C512.996 324.882 494.676 344.495 494.676 374.144C494.676 403.793 517.307 424.485 549.638 424.485C578.427 424.485 620.918 403.483 620.918 346.501V166.137C620.918 155.019 623.228 152.394 633.389 150.078L721.297 130.775C727.454 129.385 731.304 124.752 731.304 118.421Z" 
              />
            </g>
            <line 
              className="logo-path logo-path-3" 
              x1="71.0057" 
              y1="483.833" 
              x2="687.72" 
              y2="483.833" 
              strokeWidth="15" 
              strokeLinecap="round"
            />
            <defs>
              <clipPath id="clip0_2002_1423">
                <rect width="242.324" height="404.431" fill="white" transform="translate(494.676 20.0544)"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        
        <div className="loading-text">
          <h1 className="loading-title">Stage<span style={{ color: "#818cf8" }}>Note</span><span>.</span><span style={{ color: "#818cf8" }}>ai</span></h1>
          <p className="loading-subtitle">Business Portal</p>
        </div>
        
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
      </div>
      
      <div className="loading-bg-pattern">
        <div className="pattern-circle pattern-circle-1"></div>
        <div className="pattern-circle pattern-circle-2"></div>
        <div className="pattern-circle pattern-circle-3"></div>
      </div>
    </div>
  );
};

